import { Component } from '@angular/core';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CreateEditWindowComponent } from './create-edit-window.component';
import { IntlService } from '@progress/kendo-angular-intl';
import { User } from '@app/core/models';
import { ZonedDate } from "@progress/kendo-date-math";
import { environment } from '@environments/environment';


@Component({
  selector: 'create-edit-payment',
  template: `
  <div class="k-overlay" *ngIf="opened"></div>
  <kendo-window [width]="400" title="{{ (mode == 'CREATE') ? 'Nuevo' : 'Editar' }} {{ label }} {{ (mode == 'CREATE') ? '' : '(Id: ' + form.value.id + ')' }}" *ngIf="opened" (close)="onClose()" [(state)]="windowState">
  
    <!-- {{ form.value | json }} Es valido: {{ form.valid }} -->
    
    <form novalidate [formGroup]="form">
      <div class="example-wrapper form-detail">        
          <div class="row">              
              <div class="col-xs-12 col-sm-12 example-col">
                  <kendo-label text="Fecha:"></kendo-label>
                  <kendo-textbox-container>
                    <kendo-datepicker formControlName="date" [format]="'dd-MMM-yyyy'"></kendo-datepicker>
                  </kendo-textbox-container>
                  <div *ngIf="f.date.invalid && (f.date.dirty || f.date.touched)">                  
                    <div *ngIf="f.date.errors">
                      <kendo-formerror *ngIf="f.date.errors.required">
                        Error: Campo requerido.
                      </kendo-formerror>
                    </div>   
                  </div>
              </div>
              <div class="col-xs-12 col-sm-12 example-col">
                  <kendo-label text="Cantidad:"></kendo-label>
                  <p class="data-info k-color-success right">
                    {{intl.formatNumber(this.form.value.amount, "c2")}}
                  </p>                                
              </div>
              <div class="col-xs-12 col-sm-12 example-col">
                  <kendo-label text="Tipo de pago:"></kendo-label>
                  <dynamic-dropdownlist formControlName="id_payment_type" [table]="'payments_types'" [valueField]="'id'" [textField]="'name'" [showAll]="true"></dynamic-dropdownlist>
              </div>
              <div class="col-xs-12 col-sm-12 example-col">
                  <kendo-label text="Recibió:"></kendo-label>
                  <dynamic-dropdownlist formControlName="id_person" [table]="'persons'" [valueField]="'id'" [textField]="'name'" [showAll]="true"></dynamic-dropdownlist>                  
              </div>              
          </div>
      </div>
    </form>

    <div class="text-right">
        <button type="button" class="k-button" (click)="onCancel()">Cancelar</button>
        <button type="button" class="k-button k-primary ml-1" (click)="onSave()" [disabled]='!form.valid'>Guardar</button>
    </div>
       
  </kendo-window>      
  `,
  styles: [`
    .k-textbox-container, input.k-textbox {
      width: 100%;
    }
    p.data-info {
      margin-bottom: 0px;
      // font-weight: bold;
      margin-top: 8px;
      padding: 6px;
      // background-color: #ecf0f1;
      border: 1px solid #ecf0f1;
      min-height: 30px;
    }
    p.right {
      text-align: right;
    }
    .k-numeric-wrap .k-input, k-formatted-value{
      text-align:right
    }
  `],
  providers: [ DatasourceService ]
})    
export class CreateEditPaymentComponent extends CreateEditWindowComponent {

  //Métodos

  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService, protected intl: IntlService) {

    super(authService, service, alertService);

  }
  
  //@Override
  public getObjectString(dataItem: any): string {

    return [
      `Id: '${dataItem.id}'`,      
      `Fecha: '${this.intl.formatDate(dataItem.date, "yyyy-MM-dd HH:mm")}'`,
      `Cantidad: '${dataItem.amount}'`,
      `Autorizá: '${dataItem.person_name}'`,
    ].join('\n')

  };

  public process(total: number): void {

    this.mode = 'CREATE';
    this.opened = true;
    this.form = this.getFormGroup(this.currentUser);

    this.form.patchValue({
      amount: total,
    });
            
  }

  //@Override
  protected getFormGroup(user: User, dataItem?: any): FormGroup {

    const tzDate = ZonedDate.fromUTCDate((dataItem) ? new Date(dataItem.date) : new Date(), environment.timezone);

    return new FormGroup({
      'id': new FormControl((dataItem) ? dataItem.id: 0),     
      'date': new FormControl((dataItem) ? new Date(tzDate.toUTCString().replace('Dev', 'Dec')): new Date(), Validators.required), 
      'amount': new FormControl((dataItem) ? dataItem.amount: 0, Validators.required),
      'id_payment_type': new FormControl((dataItem) ? dataItem.id_payment_type: 0, Validators.required),
      'id_person': new FormControl((dataItem) ? dataItem.id_person: 1, Validators.required)
    });

  };

  //@Override
  protected getData(formGroup: FormGroup): Object {
    
    return Object.assign({}, formGroup.value, { 
      date: this.intl.formatDate(formGroup.value.date, "yyyy-MM-dd"),
      // output_date: null
    });

  };

  public onSave(): void {
    
    let data = this.getData(this.form);
    console.log('data', data)

    this.save.emit({mode: this.mode, dataItem: data});
    this.opened = false;

  }

}
